import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"cross\">\n    <path stroke=\"currentColor\" stroke-width=\"2\" d=\"M10 10l-8.485 8.485L10 10 1.515 1.515 10 10l8.485-8.485L10 10l8.485 8.485z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol